// src/styles/theme.js
const theme = {
    colors: {
      primary: '#1E293B',
      primaryDark: '#2851C9',
      secondary: '#FF6A3D',
      dark: '#1E293B',
      light: '#F8FAFC',
      gray100: '#F1F5F9',
      gray200: '#E2E8F0',
      gray300: '#CBD5E1',
      gray400: '#94A3B8',
      gray500: '#64748B',
      white: '#ffffff',
    },
    fonts: {
      main: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    breakpoints: {
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
    },
    shadows: {
      light: '0 2px 10px rgba(0, 0, 0, 0.05)',
      medium: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      large: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    },
  };
  
  export default theme;